import useIntl from '@/utils/intl'
import React, { FunctionComponent, useState } from 'react'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import Image from 'next/image'
import { ArrowForwardIos } from '@mui/icons-material'
import { Obj } from '..'
import { moneyFormatter } from '@/utils/helpers'
import { IMG_URL } from '@/utils/constants'
import { useTheme } from '@/context/ThemeContext'

interface Props {
  onTermsClick: () => void
  obj?: Obj
}

const StatusInfo: FunctionComponent<Props> = ({
  onTermsClick,
  obj
}) => {
  const { translate } = useIntl()
  const [show, setShow] = useState(false)
  const { theme } = useTheme()
  const displayAmount: number =
    obj?.leasingRes?.totalAmount !== undefined ? obj.leasingRes?.totalAmount : 0
  const handleTermsClick = (): void => {
    onTermsClick()
  }
  const displayAmountNumber: number = displayAmount
  const usedAmount: number = obj?.leasingRes?.usedAmount ?? 0
  const remainingAmount: number = displayAmountNumber - usedAmount

  if (obj?.leasingRes === undefined) {
    return <></>
  }
  return (
    <div className='flex flex-col h-full w-full bg-surfaceInverse'>
      <div className='flex-grow px-4 py-4 sm:px-8 sm:py-8 overflow-y-auto flex flex-col gap-4'>
        <div className='rounded-2xl w-full flex flex-col justify-between border'>
          <div
            className='rounded-2xl w-full p-4 flex flex-col justify-between border bg-no-repeat bg-cover bg-center space-y-4 bg-[#2E353B] '
            style={{ backgroundImage: `url(${IMG_URL}/uploads/leasing_card.png)` }}
          >
            <div className='flex justify-between items-center w-full'>
              <Image
                draggable={false}
                width={58}
                height={32}
                src={IMG_URL + '/uploads/icons/mobicom_logo_grey.svg'}
                alt='Mobicom logo'
                className='w-16 pt-2'
              />
              <div onClick={() => setShow(!show)} className='border p-2 rounded-2xl bg-white/50 inline-flex items-center justify-center'>
                {show
                  ? (
                    <FaEye className='w-5 h-5 text-textHigh' />
                    )
                  : (
                    <FaEyeSlash className='w-5 h-5 text-textHigh' />
                    )}
              </div>
            </div>
            <div className='flex flex-col space-y-1'>
              <div className='flex justify-between items-center w-full mt-4'>
                <div className='text-base font-bold text-white'>{!show ? moneyFormatter(displayAmount) : '---'}</div>
                <div className='text-white text-base font-bold whitespace-nowrap'>
                  {((obj.leasingRes?.expirationDate) != null)
                    ? new Date(obj.leasingRes?.expirationDate).toISOString().slice(0, 10).replace(/-/g, '/')
                    : '--'}
                </div>
              </div>
            </div>
            <div className='flex justify-between items-center w-full'>
              <div className='text-white text-sm'>
                {translate('leasing.info.monthPay')}
              </div>
              <div className='flex items-center space-x-2' />
              <div className='text-white text-sm'>
                {translate('leasing.info.date')}
              </div>
            </div>
          </div>
          <div className='flex flex-col space-y-4 pt-8 p-4'>
            <div className='w-full h-2 bg-gray-300 rounded'>
              <div
                className='h-full bg-primaryMain rounded'
                style={{ width: `${(usedAmount * 100) / displayAmount}%` }}
              />
            </div>
            <div className='flex justify-between items-center w-full'>
              <div className='text-textHigh text-sm'>
                {translate('leasing.complete.usedAmount')}: {moneyFormatter(obj?.leasingRes?.usedAmount ?? 0)}
              </div>
              <div className='text-textHigh text-sm'>
                {translate('leasing.complete.Amount')}: {moneyFormatter(remainingAmount)}
              </div>
            </div>
          </div>
        </div>
        <div className='border border-primary rounded-2xl w-full p-4 flex flex-col justify-start items-start mt-4'>
          <div className='flex items-start space-x-3'>
            <Image
              draggable={false}
              width={24}
              height={24}
              alt='benefit icon'
              src={IMG_URL + '/uploads/icons/star_icon.svg'}
              className='w-5 h-5 mt-1'
            />
            <div className='flex-1'>
              <ul className='list-disc list-inside pt-1 space-y-1'>
                <li className='text-textMid text-sm'>
                  {translate('leasing.complete.text1')}
                </li>
                <li className='text-textMid text-sm'>
                  {translate('leasing.complete.text2')}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div onClick={handleTermsClick} className='w-full mt-4'>
          <div className='border border-primary rounded-2xl px-4 py-3 flex justify-between items-center cursor-pointer hover:opacity-80'>
            <div className='flex items-center space-x-2'>
              <img
                src={IMG_URL +
                      `/uploads/icons/${
                        theme === 'dark'
                          ? 'file_dark.svg'
                          : 'file_light.svg'
                      }`}
                alt='Terms Icon'
                className='w-5 h-5 object-contain'
                draggable='false'
              />
              <div className='text-textHigh text-base'>
                {translate('leasing.info.termsofservice')}
              </div>
            </div>
            <ArrowForwardIos className='text-textMid text-sm' />
          </div>
        </div>
      </div>
    </div>
  )
}

export default StatusInfo
